import { UserModel } from 'models/userModel';

import { BaseService } from './baseService';

class UserService extends BaseService<UserModel> {
  controllerName = 'user';
}

export const userService = new UserService();
